import React, { PropTypes } from 'react';
import Dropdown from 'common/components/Dropdown';
import { displayCreationModal as displayCreateCustomer } from 'saas/customers/modals';
import cx from 'classnames';

const renderDefault = () => (
  <div className="default text">Choisissez un client</div>
);

const renderCustomer = customer => (
  <div key={customer.id} data-value={customer.id} className="item">
    {customer.name}
  </div>
);

export const CustomerSelector = ({
  customerId,
  customerChoice,
  onChange,
  onCustomerCreated,
  errors,
}) => {
  const onAddClick = evt =>
    displayCreateCustomer(evt, customer =>
      onCustomerCreated({
        id: customer.id,
        name: customer.name,
        deleted: false,
      })
    );

  const fieldClass = cx('field required', {
    error: errors.includes('customerId'),
  });

  const sortCustomers = (l, r) => {
    const lname = l.name.toLowerCase();
    const rname = r.name.toLowerCase();
    if (lname > rname) {
      return 1;
    } else if (lname < rname) {
      return -1;
    }
    return 0;
  };

  const filteredChoices = customerChoice.filter(
    c => c.deleted === false || c.id === customerId
  );
  const customers = filteredChoices.sort(sortCustomers);

  return (
    <div className="ui segment form">
      <h3 className="ui header">
        Choix du client
        <button
          id="bt-new-customer"
          type="button"
          className="ui button icon labeled floated right"
          onClick={onAddClick}
        >
          <i className="icon add" />
          Créer un nouveau client
        </button>
      </h3>
      <br />
      <div className="two fields">
        <div className={fieldClass}>
          <label>Client</label>
          <Dropdown
            name="ref_tech_id"
            value={customerId}
            items={customers}
            renderDefault={renderDefault}
            renderItem={renderCustomer}
            onChange={onChange}
            search
          />
        </div>
        <div className="field" />
      </div>
    </div>
  );
};

CustomerSelector.propTypes = {
  customerId: PropTypes.string,
  customerChoice: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onCustomerCreated: PropTypes.func.isRequired,
  errors: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases-creation/step1/components/CustomerSelector.js